export { default } from '@/components/Business/BusinessChatPage';
